import { toast } from "react-toastify";

export const notificacion = (message: string) => notificacionTipo("default", message);
export const notificacionError = (message: string) => notificacionTipo("error", message);

export const notificacionTipo = (type: "info" | "success" | "warning" | "error" | "default", message: string) => toast(message, {
	type: type,
});
